import request from '@/utils/request_2'
const gateway = '/system'
export function uploadImg(data) {
    return request({
        url: '/system/uploadImg',
        data: data,
        method: 'post'
    })
}
export function uploadFile(data) {
    return request({
        url: '/system/uploadFile',
        data,
        method: 'post'
    })
}
// 上传视频
export function uploadVideo4Article(data) { 
  return request({
    url: '/system/uploadVideo4Article',
    data,
    method: 'post'
  })
}
// 设备解绑列表
export function hardwareList(data) {
  return request({
    url: '/system/hardware/list',
    data,
    method: 'post'
  })
}
// 设备解绑
export function unbindHardwareBySystem (params) {
  return request({
    url: '/system/hardware/unbindHardwareBySystem',
    params,
    method: 'get'
  })
}
// 批量审核会员的提现申请
export function bathReviewWithdrawDeposit(data) {
  return request({
    url: `${gateway}/memberWithdrawDeposit/bathReviewWithdrawDeposit`,
    data,
    method: 'post'
  })
}
// 添加或修改会员自定义标签--运营端
export function memberCustomizeLabelSaveOrUpdate(data) {
  return request({
    url: `${gateway}/memberCustomizeLabel/saveOrUpdate`,
    data,
    method: 'post'
  })
}
// 根据会员ID查询会员自定义标签--运营端
export function getMemberLabelByMemberId(params) {
  return request({
    url: `${gateway}/memberCustomizeLabel/getMemberLabelByMemberId`,
    params,
    method: 'get'
  })
}
// 删除会员自定义标签--运营端
export function deleteMemberLabel(params) {
  return request({
    url: `${gateway}/memberCustomizeLabel/deleteMemberLabel`,
    params,
    method: 'get'
  })
}
// 会员卡券页面统计--运营端
export function allCardDataStatistic(params) {
  return request({
    url: `${gateway}/cardDataStatisticDaily/allCardDataStatistic`,
    params,
    method: 'get'
  })
}
// [运营端]-分页查询卡劵信息
export function cardCouponListByPage(data) {
  return request({
    url: `${gateway}/cardCoupon/listByPage`,
    method: 'post',
    data
  })
}
// 获取去重后的会员标签名称-运营端
export function getDistinctMemberNames(params) {
  return request({
    url: `${gateway}/memberCustomizeLabel/getDistinctMemberNames`,
    method: 'get',
    params
  })
}
// 根据会员等级，会员自定义标签获取会员名称的集合--运营端
export function getMemberNamesByLevelLabel(params) {
  return request({
    url: `${gateway}/member/getMemberNamesByLevelLabel`,
    method: 'get',
    params
  })
}
// 系统分发卡券-运营端
export function systemDispatchCard(data) {
  return request({
    url: `${gateway}/cardCoupon/systemDispatchCard`,
    method: 'post',
    data
  })
}
// 根据活动ID查询活动对应的药企配置列表
export function activityEnterpriseConfigList(params) {
  return request({
    url: `${gateway}/activityEnterpriseRelation/activityEnterpriseConfigList`,
    method: 'get',
    params
  })
}
/** 按药企查询活动列表 GET /activityEnterpriseRelation/activityListByEnterpriseId */
export function activityListByEnterpriseId(params) {
  return request({
    url: `${gateway}/activityEnterpriseRelation/activityListByEnterpriseId`,
    method: 'get',
    params
  })
}
// 活动药企配置批量保存（活动配置药企列表勾选保存）
export function activityEnterpriseConfigBatchSave(data) {
  return request({
    url: `${gateway}/activityEnterpriseRelation/activityEnterpriseConfigBatchSave`,
    method: 'post',
    data
  })
}
// 新增/更新门店返现配置信息
export function storeReturnCashConfigSaveOrUpdate(data) {
  return request({
    url: `${gateway}/storeReturnCashConfig/saveOrUpdate`,
    method: 'post',
    data
  })
}
// 门店返现配置信息启用状态更新，配置状态（1：启用，0：禁用）
export function storeReturnCashConfigStatusUpdate(params) {
  return request({
    url: `${gateway}/storeReturnCashConfig/statusUpdate`,
    method: 'get',
    params
  })
}
//获取门店返现配置列表
export function storeReturnCashConfigList(data) {
  return request({
    url: `${gateway}/storeReturnCashConfig/list`,
    method: 'post',
    data
  })
}
// 查询是否允许提交
export function isAllowSubmit(params) {
  return request({
    url: `${gateway}/storeReturnCashConfig/isAlreadyConfig`,
    method: 'get',
    params
  })
}
// 获取药企以旧换新配置列表接口
export function enterpriseTradeInConfigList(data) {
  return request({
    url: `${gateway}/enterpriseTradeInConfig/list`,
    method: 'post',
    data
  })
}
// 根据主键ID获取以旧换新配置详情接口
export function enterpriseTradeInConfigQueryById(params) {
  return request({
    url: `${gateway}/enterpriseTradeInConfig/queryById`,
    method: 'get',
    params
  })
}
// 新增/更新药企以旧换新配置数据接口：
export function enterpriseTradeInConfigSaveOrUpdate(data) {
  return request({
    url: `${gateway}/enterpriseTradeInConfig/saveOrUpdate`,
    method: 'post',
    data
  })
}
// 药企以旧换新配置数据状态修改接口：
export function enterpriseTradeInConfigStatusUpdate(params) {
  return request({
    url: `${gateway}/enterpriseTradeInConfig/statusUpdate`,
    method: 'get',
    params
  })
}
// 获取未配置以旧换新的药企列表接口：
export function getNotConfigTradeInEnterpriseList(params) {
  return request({
    url: `${gateway}/enterpriseTradeInConfig/getNotConfigTradeInEnterpriseList`,
    method: 'get',
    params
  })
}
// 删除以旧换新的药企列表接口
export function enterpriseTradeInConfigDeleteById(params) {
  return request({
    url: `${gateway}/enterpriseTradeInConfig/deleteById`,
    method: 'get',
    params
  })
}
// 根据返现记录主键id获取会员返现记录条件配置列表
export function memberReturnCashRecordList(data) {
  return request({
    url: `${gateway}/memberReturnCashRecord/list`,
    method: 'post',
    data
  })
}
// 根据返现记录主键id获取会员返现记录条件配置列表
export function conditionConfigByRecordId(params) {
  return request({
    url: `${gateway}/memberReturnCashRecord/conditionConfigByRecordId`,
    method: 'get',
    params
  })
}
// 返现记录条件配置保存
export function memberReturnCashRecordConditionConfigSave(parasm) {
  return request({
    url: `${gateway}/memberReturnCashRecord/conditionConfigSave`,
    method: 'get',
    parasm
  })
}
// 获取卡券核销列表(运营端/药企端)
export function cardVerifyList(data) {
  return request({
    url: `/system/cardVerify/list`,
    method: 'post',
    data
  })
}
// 会员卡券核销（旧单页）
export function verifyMemberCard(data) {
  return request({
    url: `/system/cardVerify/verifyMemberCard`,
    method: 'post',
    data
  })
}

/** 识别券码类型 GET /system/cardVerify/identify?code=
 * 返回：{ code: 200, msg, data: { type: 'ACTIVITY' | 'MEMBER_CARD' } }
 */
export function identifyVerifyCode(code) {
  return request({
    url: `/system/cardVerify/identify`,
    method: 'get',
    params: { code }
  })
}

/**
 * 统一核销 POST /system/cardVerify/verify
 * MEMBER_CARD: { type, memberCardParam: { cardNum, memberId, storeId } }
 * ACTIVITY: { type, activityParam: { verificationCode, phoneNum, storeId } }
 */
export function cardVerifyUnified(data) {
  return request({
    url: `/system/cardVerify/verify`,
    method: 'post',
    data
  })
}